import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Modal } from "../../components/modal";
import { PropertyForm, PropertyFormValues } from "../../components/property-form";
import { createProperty } from "../../services/property";
import { navigateBack } from "../../utils/navigate-back";

export function MaintenancePropertyCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [formValues, setFormValues] = useState<PropertyFormValues>({
    name: "",
    parts: [],
  });

  const closeModal = () => {
    navigateBack(navigate, "/admin/maintenance/property");
  };

  return (
    <Modal open onClose={closeModal}>
      <PropertyForm
        hasError={hasError}
        loading={loading}
        values={formValues}
        onCancel={closeModal}
        onChange={setFormValues}
        onSubmit={() => {
          void (async () => {
            setLoading(true);
            setHasError(false);
            try {
              await createProperty({
                name: formValues.name,
                parts: formValues.parts.map((part) => ({
                  code: part.code,
                  name: part.name,
                })),
              });
              await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["properties"] }),
                queryClient.invalidateQueries({ queryKey: ["propertyParts"] }),
              ]);
              closeModal();
            } catch {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </Modal>
  );
}
